import { render, staticRenderFns } from "./BatchRunList.vue?vue&type=template&id=cfaa0aa0&scoped=true"
import script from "./BatchRunList.vue?vue&type=script&lang=js"
export * from "./BatchRunList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaa0aa0",
  null
  
)

export default component.exports